import classNames from "classnames";
import styles from "./RelevanceRating.module.css";

export type Rating = 1 | 2 | 3 | 4 | 5 | "X";

const ratingLabels: Record<Rating, string> = {
  1: "Not Relevant",
  2: "Tangentially Relevant",
  3: "Domain Relevant",
  4: "Highly Relevant",
  5: "Exactly Relevant",
  X: "Relevance Error",
};

export default function RelevanceRating({
  rating,
  ratingOnly = false,
}: {
  rating?: Rating | null;
  ratingOnly?: boolean;
}) {
  if (!rating) {
    return null;
  }

  return (
    <span className={classNames(rating && styles[`rating-${rating}`])}>
      <strong>{rating}</strong>
      {!ratingOnly && ratingLabels[rating] && <>, {ratingLabels[rating]}</>}
    </span>
  );
}
